import React from 'react'
export type Props = {
  caption?: string
  children?: React.ReactNode
  reducedMargins?: boolean
}

const FilterRow = (props: Props): React.ReactElement<'div'> => {
  const { caption, children, reducedMargins } = props
  const optionsClassName = reducedMargins
    ? 'SearchResults_FilterOptions_ReducedMargin'
    : 'SearchResults_FilterOptions'
  return (
    <div>
      <div className="SearchResults_FilterLabel">{caption}</div>
      <div className={optionsClassName}>{children}</div>
    </div>
  )
}

export default FilterRow
